function defaultCellFormatter(value) {
  return value;
}

export default defaultCellFormatter;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/ReadManyLib/defaultCellFormatter.js